import { room_passenger } from "./Room_Passenger";

export class room {
    public room_type: string | null = null;
    public passengers: room_passenger[] = [];
}